/** Compact dates have no timezone: compare their provider clocks, not the browser's timezone. */
function timestamp(value: string | null): { time: number; compact: boolean } | null {
  if (!value) return null;
  const compact = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/.exec(value);
  if (compact) {
    const [year, month, day, hour, minute, second] = compact.slice(1).map(Number);
    const time = Date.UTC(year, month - 1, day, hour, minute, second);
    const date = new Date(time);
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day || date.getUTCHours() !== hour || date.getUTCMinutes() !== minute || date.getUTCSeconds() !== second) return null;
    return { time, compact: true };
  }
  if (!/^\d{4}-\d{2}-\d{2}T.*(?:Z|[+-]\d{2}:\d{2})$/i.test(value)) return null;
  const time = Date.parse(value);
  return Number.isFinite(time) ? { time, compact: false } : null;
}

export function fiscalShiftDuration(openedAt: string | null, closedAt: string | null): { days: number; clock: string } | null {
  const start = timestamp(openedAt);
  const end = timestamp(closedAt);
  if (!start || !end || start.compact !== end.compact || end.time < start.time) return null;
  const seconds = Math.floor((end.time - start.time) / 1000);
  const clock = [Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60]
    .map((part) => String(part).padStart(2, '0')).join(':');
  return { days: Math.floor(seconds / 86400), clock };
}
